import type { DirectusImage } from '@/types/directus';

const URL_TEMPLATE = `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/:id`;

type AssetUrlOptions = {
  width?: number;
  height?: number;
  fit?: 'cover' | 'contain' | 'inside' | 'outside';
  quality?: number;
  format?: string;
  version?: string;
};

export function assetUrl(
  image: string | DirectusImage | undefined,
  options?: AssetUrlOptions
): string | undefined {
  if (!image) return undefined;
  const id = typeof image === 'string' ? image : image.id;
  if (!id) return undefined;

  let url = URL_TEMPLATE.replace(':id', id);
  const params = new URLSearchParams();

  // Expect the version to be a string. Remove non-numeric characters.
  // If no version is found, default to '1'.
  let version =
    options?.version || (typeof image !== 'string' ? image.modified_on : '1');
  version = version.replace(/[\D]/g, '');
  if (version) params.append('v', version);

  // Add any further options to the URL
  if (options) {
    if (options.width) params.append('width', String(options.width));
    if (options.height) params.append('height', String(options.height));
    if (options.fit) params.append('fit', options.fit);
    if (options.quality) params.append('quality', String(options.quality));
    if (options.format) params.append('format', options.format);
  }

  url += `?${params.toString()}`;
  return url;
}
